/* @flow */

import getDadosFormulario from './get-formulario';
import xhr from '../../utils/xhr';
import mensagemSucesso from './mensagem-sucesso';
import exibirErro from '../../utils/exibir-erro';
import getElementoPorId from '../../utils/get-elemento-por-id';
import proximaEtapa from './proximaEtapa';
import { editarEstabelecimento } from '../eventos-formularios/estabelecimento';

const cadastroEndereco = (empresasId: number) => {
    const form = getElementoPorId('formulario-endereco');
    form.onsubmit = async (e) => {
        e.preventDefault();
        const dados = getDadosFormulario(form);
        try {
            await xhr.post('/enderecos', ({
                ...getDadosFormulario(form),
                empresasId,
            }));
            await editarEstabelecimento(empresasId, { retiradaLocal: dados.retiradaLocal });
            mensagemSucesso('Endereço cadastrado.');
            proximaEtapa('cobranca');
        } catch (err) {
            exibirErro(err);
        }
    };
};

export default cadastroEndereco;
